import { trimBraces } from '../api/inbound/inboundUtils';
import { CARD_SUIT_BLACK_COLOR_NUM, CARD_SUIT_BLUE_COLOR_NUM, CARD_SUIT_GREEN_COLOR_NUM, CARD_SUIT_RED_COLOR_NUM } from '../styles/colors';
import { CARD_ASSET_URLS } from '../utils/loaderUtils';
export const NUM_TOTAL_COMMUNITY_CARDS = 5;
export const ALL_CARD_SUIT_CHARS = ['c', 'd', 'h', 's'];
export const ALL_CARD_RANKS = ['2', '3', '4', '5', '6', '7', '8', '9', 'T', 'J', 'Q', 'K', 'A']; // in order
export const CARD_RANK_LABELS = {
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    T: '10',
    J: 'J',
    Q: 'Q',
    K: 'K',
    A: 'A'
};
export const CARD_RANK_FULL_LABELS = {
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    T: '10',
    J: 'Jack',
    Q: 'Queen',
    K: 'King',
    A: 'Ace'
};
const SUIT_CHAR_MAP = {
    c: 'club',
    d: 'diamond',
    h: 'heart',
    s: 'spade'
};
const CARD_SUIT_LABELS = {
    c: '♣️',
    d: '♦️',
    h: '♥️',
    s: '♠️'
};
export function isCard(cardOrNot) {
    return !!cardOrNot;
}
function isCardRankChar(rankChar) {
    return ALL_CARD_RANKS.indexOf(rankChar) !== -1;
}
function isCardSuitChar(suitChar) {
    return !!SUIT_CHAR_MAP[suitChar];
}
export function cardStringParser(cardStr) {
    const rankChar = cardStr.substr(0, 1);
    if (!isCardRankChar(rankChar)) {
        throw new Error(`card string '${cardStr}' could not be parsed -- unknown card rank`);
    }
    const suitChar = cardStr.substr(1);
    if (!isCardSuitChar(suitChar)) {
        throw new Error(`card string '${cardStr}' could not be parsed -- unknown card suit`);
    }
    return {
        shorthand: `${rankChar}${suitChar}`,
        rank: ALL_CARD_RANKS.indexOf(rankChar),
        rankChar,
        rankCardLabel: CARD_RANK_LABELS[rankChar],
        suit: SUIT_CHAR_MAP[suitChar],
        suitChar,
        suitCardLabel: CARD_SUIT_LABELS[suitChar]
    };
}
export function holeCardsParser(str) {
    const cardsString = trimBraces(str);
    if (!cardsString) {
        // handle hand spectator's `h:{},...` packet form
        return [];
    }
    return cardsString.split(',').map(cardStringParser);
}
export function getCardSuitAssetUrl(cardSuitChar, isFourColorDeck) {
    switch (cardSuitChar) {
        case 'c': {
            return isFourColorDeck ? CARD_ASSET_URLS['suit-club-4color-deck'] : CARD_ASSET_URLS['suit-club'];
        }
        case 'd': {
            return isFourColorDeck ? CARD_ASSET_URLS['suit-diamond-4color-deck'] : CARD_ASSET_URLS['suit-diamond'];
        }
        case 'h': {
            return CARD_ASSET_URLS['suit-heart'];
        }
        case 's': {
            return CARD_ASSET_URLS['suit-spade'];
        }
    }
}
export function getCardShorthand(cardRankChar, cardSuitChar) {
    return `${cardRankChar}${cardSuitChar}`;
}
export function getSuitColorNum(cardSuitChar, isFourColorDeck) {
    switch (cardSuitChar) {
        case 'c': {
            return isFourColorDeck ? CARD_SUIT_GREEN_COLOR_NUM : CARD_SUIT_BLACK_COLOR_NUM;
        }
        case 'd': {
            return isFourColorDeck ? CARD_SUIT_BLUE_COLOR_NUM : CARD_SUIT_RED_COLOR_NUM;
        }
        case 'h': {
            return CARD_SUIT_RED_COLOR_NUM;
        }
        case 's': {
            return CARD_SUIT_BLACK_COLOR_NUM;
        }
    }
}
